"use client"

import { useState } from "react"
import { motion } from "framer-motion"
import { Download, AlertCircle } from "lucide-react"

const TikTokDownloader = () => {
  const [url, setUrl] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [videoInfo, setVideoInfo] = useState(null)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)
    setError(null)
    setVideoInfo(null)

    const myHeaders = new Headers()
    myHeaders.append("accept", "*/*")
    myHeaders.append("accept-language", "en-US,en;q=0.9")
    myHeaders.append("content-type", "application/x-www-form-urlencoded")
    myHeaders.append("x-apihub-key", "dC-X6X1n75W9ul7oEz2tOmvuaww1WLB3cGiKWsfsq057qO4-Ay")
    myHeaders.append("x-apihub-host", "Video-Downloader.allthingsdev.co")
    myHeaders.append("x-apihub-endpoint", "26c3c680-6530-4bb3-be5f-edd3428f5fde")

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    }

    try {
      const response = await fetch(
        `https://Video-Downloader.proxy-production.allthingsdev.co/tiktok/download?url=${encodeURIComponent(url)}`,
        requestOptions,
      )
      const result = await response.json()

      if (response.ok) {
        setVideoInfo(result)
      } else {
        throw new Error(result.message || "Failed to fetch video information")
      }
    } catch (error) {
      console.error("Error:", error)
      setError(error.message || "An error occurred while processing your request")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto px-4">
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 448 512"
          className="w-12 h-12 mx-auto mb-4 fill-current text-black dark:text-white"
        >
          <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z" />
        </svg>
        <h1 className="text-4xl font-bold text-gray-900 dark:text-white">TikTok Video Downloader</h1>
        <p className="text-lg text-gray-600 dark:text-gray-300 mt-2">Download your favorite TikTok videos easily!</p>
      </motion.div>

      <motion.form
        onSubmit={handleSubmit}
        className="mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        <div className="flex flex-col sm:flex-row gap-4">
          <input
            type="url"
            placeholder="Paste TikTok video URL here"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
            className="flex-grow px-4 py-2 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-black dark:focus:ring-white dark:bg-gray-700 dark:border-gray-600 dark:text-white"
          />
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 bg-black text-white dark:bg-white dark:text-black rounded-md hover:bg-gray-800 dark:hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-black dark:focus:ring-white focus:ring-opacity-50 transition-colors duration-300 flex items-center justify-center"
          >
            {loading ? (
              <span className="animate-pulse">Processing...</span>
            ) : (
              <>
                <Download className="mr-2" size={18} />
                Download
              </>
            )}
          </button>
        </div>
      </motion.form>

      {error && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 mb-8"
          role="alert"
        >
          <div className="flex items-center">
            <AlertCircle className="mr-2" size={18} />
            <p>{error}</p>
          </div>
        </motion.div>
      )}

      {videoInfo && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="bg-white dark:bg-gray-800 rounded-lg shadow-lg overflow-hidden"
        >
          <div className="p-6">
            <h2 className="text-2xl font-bold mb-4 dark:text-white">{videoInfo.title}</h2>
            <img
              src={videoInfo.thumbnail_url || "/placeholder.svg"}
              alt="Video Thumbnail"
              className="w-full rounded-lg mb-4"
            />
            <a
              href={videoInfo.download_url}
              download
              className="block w-full bg-black text-white dark:bg-white dark:text-black px-4 py-2 rounded-md hover:bg-gray-800 dark:hover:bg-gray-200 transition-colors duration-300 text-center"
            >
              Download Video
            </a>
          </div>
        </motion.div>
      )}
    </div>
  )
}

export default TikTokDownloader

